import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-left mt20" }
const _hoisted_2 = { class: "pad20" }
const _hoisted_3 = {
  key: 0,
  class: "fl mt20 text-left"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "日程確定の有無", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs16" }, "確定型", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "日程をお相手が確定します", -1)
const _hoisted_8 = { class: "pad9" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs16" }, "提案型", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "日程をお相手が確定しません", -1)
const _hoisted_13 = { class: "pad5" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  class: "mt40 w100",
  style: {}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, [
  /*#__PURE__*/_createTextVNode(" 時間の上に表示するテキストを変更できます。（40文字以内）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" デフォルトでは「ご都合の良い時間を選択してください」が表示されます。 ")
], -1)
const _hoisted_20 = {
  key: 1,
  class: "w100 mt40",
  style: {}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "日程を確定しないお相手の提案下限件数", -1)
const _hoisted_22 = {
  class: "mt10",
  style: {"width":"60px"}
}
const _hoisted_23 = {
  class: "mt10 w100",
  style: {}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, [
  /*#__PURE__*/_createTextVNode(" 提案形式の場合、表示するテキストを変更できます。（40文字以内）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" デフォルトでは「可能な日程を最低◯件選択してください」が表示されます。 ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt17 mr5" }, "提案状況を", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "w100 mt40 rad8"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "同一時間帯に確定可能な枠数", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 mt10" }, " 一担当者あたりの同一時間帯に複数の予約を受け付けることが可能になります。（例： セミナー、集団面接など） ", -1)
const _hoisted_37 = {
  key: 0,
  class: "dgrey fs12 fw600"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = {
  class: "mt10",
  style: {"width":"60px"}
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, "残り枠数の表示", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = {
  key: 0,
  class: "pad20"
}
const _hoisted_45 = { class: "w100 rad8" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "デザイン形式", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, [
  /*#__PURE__*/_createTextVNode(" デザインを変更します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 通常: 通常のデザイン。説明文のあるヘッダーの下に日程・フォームが表示されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" セミナー用: ヘッダーの説明文が長くても、右に固定されたフォームと日程が表示されます。※埋め込みでの利用には適しません ")
], -1)
const _hoisted_48 = { class: "fl mt20 text-left" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "pad20"
}
const _hoisted_52 = { class: "w100 rad8" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "カレンダー表示形式", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 日程を確定・提案できる日程を事前に指定します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 指定した期間を過ぎた場合、自動的に日程が表示されなくなります。 ")
], -1)
const _hoisted_55 = { class: "fl mt20 text-left" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = {
  key: 0,
  style: {"margin-top":"30px"}
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "タイムゾーンの変更", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 調整相手がタイムゾーンの変更を有効にします。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 調整相手は、利用端末で設定しているタイムゾーンで日程が表示されます。 ")
], -1)
const _hoisted_62 = { class: "ml3 mt10" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: `can_change_tz_`,
  class: "fs13 pointer"
}, " タイムゾーン変更を表示", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = { style: {"margin-top":"30px"} }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "調整可能時間のタイムゾーン", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, " 調整可能時間で設定するタイムゾーンを以下のタイムゾーンを基準に空き時間を算出します。 ", -1)
const _hoisted_69 = { class: "fl mt20 text-left" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_timezone_avaialble_time_`,
  class: "fs13"
}, "調整可能時間のタイムゾーンを変更する", -1)
const _hoisted_71 = {
  key: 0,
  class: "ml3 mt10"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = {
  key: 4,
  class: "mt40 pad20"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "キャンセル可能期限", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_76 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_77 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" キャンセルしたい/再調整したいボタンの表示期限を設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("期間を設ける場合、最大60日前まで設定可能です。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "alert-warning" }, "※オーナーは常に表示されます。")
], -1)
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_83 = { class: "input-group" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt18 ml5" }, "までキャンセル・再調整可能", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_86 = { key: 3 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_90 = {
  key: 0,
  class: "mt40"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "別日程をリクエストボタンの表示", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_93 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_94 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, "再調整時など別日程をリクエストするボタンの表示設定を行います。", -1)
const _hoisted_96 = {
  class: "mt10",
  style: {"width":"60px"}
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_98 = {
  key: 1,
  class: "mt40"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "メール上で日程候補表示件数", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_101 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_102 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, " 調整相手が日程を確定できる場合にメール上に日程候補を表示し、確定を促すことができます。 ", -1)
const _hoisted_104 = {
  class: "mt10",
  style: {"width":"60px"}
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_106 = { class: "mt40" }
const _hoisted_107 = /*#__PURE__*/_createStaticVNode("<div class=\"header_title fs18 fl\" style=\"\"><p class=\"header_title fs18 fl\" style=\"\">仲介メニュー</p><div class=\"clear\"></div><p class=\"fs13 fl dgrey\" style=\"\"> この公開ページに提案があった場合に、提案があった日程を自動で別の公開ページにコピーできるようになります。 </p><div class=\"clear\"></div></div><div class=\"clear\"></div>", 2)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsiderationTravelMode = _resolveComponent("ConsiderationTravelMode")!
  const _component_AssignMagContent = _resolveComponent("AssignMagContent")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_OpenPeriodSettingsContent = _resolveComponent("OpenPeriodSettingsContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_TimezoneSelectContent = _resolveComponent("TimezoneSelectContent")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SpanSlotContent = _resolveComponent("SpanSlotContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConsiderationTravelMode),
    _createVNode(_component_AssignMagContent, {
      from: `room_settings`,
      onSavedAstagFromChild: _ctx.savedAstagFromChild
    }, null, 8, ["onSavedAstagFromChild"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.rcm.appo && _ctx.rcm.room_setting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", {
              class: _normalizeClass(`centered fl padw10 circle_button blueAround ${
                        _ctx.rcm.appo.fix_type == 1 ? `` : `selected`
                    } rad20 pointer l4`),
              style: {"width":"200px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickFixType && _ctx.clickFixType(...args)))
            }, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/fix_button.png`),
                  width: "80",
                  height: "32",
                  class: "pointer mt1 mt20 mb20"
                }, null, 8, _hoisted_9)
              ]),
              _hoisted_10
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`centered fl padw10 circle_button blueAround ${
                        _ctx.rcm.appo.fix_type == 1 ? `selected` : ``
                    } rad20 ml10 pointer l4`),
              style: {"width":"200px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickFixType && _ctx.clickFixType(...args)))
            }, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/vote.png`),
                  width: "60",
                  height: "60",
                  class: "pointer mt1 mt10 mb10"
                }, null, 8, _hoisted_14)
              ]),
              _hoisted_15
            ], 2),
            _hoisted_16,
            _createElementVNode("div", null, [
              (_ctx.rcm.appo.fix_type == 100)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_MdTextfieldTag, {
                        name: "",
                        style: {"height":"56px","min-width":"200px","margin-top":"-15px","width":"320px"},
                        fieldStyle: "width:320px;",
                        class: "fs20",
                        value: _ctx.rcm.room_setting?.select_time_text || ``,
                        maxLength: 40,
                        type: "text",
                        onInputValue: _ctx.inputSelectTimeText
                      }, null, 8, ["value", "onInputValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.rcm.appo.fix_type != 100)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_MdTextfieldTag, {
                        name: "",
                        style: {"height":"56px","min-width":"60px"},
                        fieldStyle: `min-width:60px;font-size:20px;`,
                        class: "fs20",
                        value: _ctx.rcm.room_setting.submit_lower_limit_num ? _ctx.rcm.room_setting.submit_lower_limit_num : 0,
                        type: "number",
                        min: 0,
                        onInputValue: _ctx.inputSubmitNum,
                        required: ""
                      }, null, 8, ["value", "onInputValue"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_MdTextfieldTag, {
                        name: "",
                        style: {"height":"56px","min-width":"200px","margin-top":"-15px","width":"320px"},
                        fieldStyle: "width:320px;",
                        class: "fs20",
                        value: _ctx.rcm.room_setting?.vote_warning_text || ``,
                        maxLength: 40,
                        type: "text",
                        onInputValue: _ctx.inputVoteWarningText
                      }, null, 8, ["value", "onInputValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_25
            ]),
            _hoisted_26,
            (_ctx.rcm.appo.fix_type != 100)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_SelectTag, {
                    name: "show_vote_type",
                    id: "select_show_vote_type",
                    class: "fl fs14 roundForm",
                    style: {"min-width":"130px","height":"50px"},
                    options: _ctx.SelectUtil.selectShowVoteTypes.map(t => t.name),
                    defaultOption: _ctx.getShowVoteType,
                    onSelectValue: _ctx.selectShowVoteType
                  }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                  _hoisted_29,
                  (_ctx.rcm.room_setting.show_vote_type != `hide_all`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_SelectTag, {
                          name: "show_filter_vote_type",
                          id: "select_show_filter_vote_type",
                          class: "fl fs14 roundForm",
                          style: {"min-width":"130px","height":"50px"},
                          options: _ctx.SelectUtil.selectShowFilterVoteTypes.map(t => t.name),
                          defaultOption: _ctx.getShowFilterVoteType,
                          onSelectValue: _ctx.selectShowFilterVoteType
                        }, null, 8, ["options", "defaultOption", "onSelectValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_31
                ]))
              : _createCommentVNode("", true),
            _hoisted_32
          ]))
        : _createCommentVNode("", true),
      _hoisted_33,
      (_ctx.rcm.room.room_type == `public_room`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _hoisted_36,
            (_ctx.rcm.room.max_bookings_num > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, " ※ 枠を設定する場合、調整カレンダーの編集より「手動モード」で日程を入れてください。 "))
              : _createCommentVNode("", true),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_MdTextfieldTag, {
                name: "",
                style: {"height":"56px","min-width":"60px"},
                fieldStyle: `min-width:60px;font-size:20px;`,
                class: "fs20",
                type: `number`,
                min: 1,
                max: 999,
                value: _ctx.rcm.room.max_bookings_num,
                onInputValue: _ctx.inputNumberOfBookings,
                onBlur: _ctx.blurNumberOfBookings
              }, null, 8, ["value", "onInputValue", "onBlur"])
            ]),
            (_ctx.rcm.room.max_bookings_num > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_SelectTag, {
                    name: "show_max_bookings_show_type",
                    id: "select_max_bookings_show_type",
                    class: "fl fs14 roundForm",
                    style: {"min-width":"130px","height":"50px"},
                    options: _ctx.SelectUtil.selectMaxBookingsShowTypes.map(t => t.name),
                    defaultOption: _ctx.getMaxBookingsShowType,
                    onSelectValue: _ctx.selectMaxBookingsShowType
                  }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                  _hoisted_42
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_43
    ]),
    (_ctx.rcm.room.room_type == `public_room`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_SelectTag, {
                class: "fl fs14 roundForm",
                style: {"min-width":"30px","height":"50px"},
                options: _ctx.SelectUtil.designTypes.map(mt => mt.name),
                optionName: `design_type`,
                defaultOption: _ctx.getDesignType(),
                onSelectValue: _ctx.selectDesignType
              }, null, 8, ["options", "defaultOption", "onSelectValue"])
            ]),
            _hoisted_49
          ]),
          _hoisted_50
        ]))
      : _createCommentVNode("", true),
    (_ctx.rcm.room.room_type == `public_room`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              _createVNode(_component_SelectTag, {
                class: "fl fs14 roundForm",
                style: {"min-width":"30px","height":"50px"},
                options: _ctx.SelectUtil.calendarShowTypes.map(mt => mt.name),
                optionName: `calendar_show_type`,
                defaultOption: _ctx.getDefaultCalendarShowType(),
                onSelectValue: _ctx.selectCalendarShowType
              }, null, 8, ["options", "defaultOption", "onSelectValue"])
            ]),
            _hoisted_56
          ]),
          _hoisted_57
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OpenPeriodSettingsContent),
    (_ctx.rcm.room_setting)
      ? (_openBlock(), _createElementBlock("section", {
          key: 2,
          class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
        }, [
          _hoisted_58,
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _hoisted_60,
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `is_private`,
                    checked: _ctx.rcm.room_setting.can_change_timezone,
                    prefix: `can_change_tz`,
                    onClickCheckbox: _ctx.clickChangeTimezone,
                    style: {"margin-left":"1px"}
                  }, null, 8, ["checked", "onClickCheckbox"]),
                  _hoisted_63
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_64
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.rcm.room_setting)
      ? (_openBlock(), _createElementBlock("section", {
          key: 3,
          class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
        }, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_CheckboxTag, {
                value: ``,
                name: `use_timezone_avaialble_time`,
                checked: _ctx.Util.isPresent(_ctx.rcm.room_setting.timezone_value) || _ctx.isAvailableTimezone,
                prefix: `use_timezone_avaialble_time`,
                onClickCheckbox: _ctx.clickUseTimezoneAvailableTime,
                style: {"margin-left":"1px","margin-right":"7px"}
              }, null, 8, ["checked", "onClickCheckbox"]),
              _hoisted_70
            ]),
            (_ctx.Util.isPresent(_ctx.rcm.room_setting.timezone_value) || _ctx.isAvailableTimezone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createVNode(_component_TimezoneSelectContent, {
                    onSelectTimezone: _ctx.selectTimezone,
                    defaultTimezone: _ctx.defaultTimezone
                  }, null, 8, ["onSelectTimezone", "defaultTimezone"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_72
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.rcm.room_setting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
          _hoisted_74,
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createVNode(_component_SelectTag, {
                name: "cancel_span_names",
                id: "select_cancel_span_names",
                class: "fl fs14 roundForm",
                style: {"min-width":"250px","height":"50px"},
                options: (_ctx.SelectUtil.cancelSpanTypes || []).map(seldic => seldic.name),
                defaultOption: _ctx.cancelSpanType,
                needUnselect: false,
                onSelectValue: _ctx.selectCancelSpanType
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              (!_ctx.rcm.room_setting.available_cancel_min_before_appo_start_time)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                : (_ctx.rcm.room_setting.available_cancel_min_before_appo_start_time == -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                  : (_ctx.rcm.room_setting.available_cancel_min_before_appo_start_time == -2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _hoisted_82,
                        _createVNode(_component_Dropdown, {
                          class: "form-group fl mt10",
                          style: {"width":"140px","margin-left":"100px"}
                        }, {
                          dropdown: _withCtx(() => [
                            _createElementVNode("li", null, [
                              _createVNode(_component_date_picker, {
                                modelValue: _ctx.cancelSpanDate,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cancelSpanDate) = $event)),
                                format: "yyyy/MM/dd"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_83, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control dropdown-toggle",
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cancelSpanDate) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.cancelSpanDate]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _hoisted_84,
                        _hoisted_85
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                        _hoisted_87,
                        _createVNode(_component_SpanSlotContent, {
                          mins: _ctx.rcm.room_setting.available_cancel_min_before_appo_start_time,
                          afterText: `前までキャンセル・再調整可能`,
                          min: _ctx.Const.minDayMins,
                          max: _ctx.Const.maxDayMins,
                          onUpdateSpan: _ctx.updateSpan
                        }, null, 8, ["mins", "min", "max", "onUpdateSpan"]),
                        _hoisted_88
                      ]))
            ])
          ]),
          _hoisted_89,
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _hoisted_91,
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("div", _hoisted_96, [
                      _createVNode(_component_SelectTag, {
                        name: "mail_style",
                        id: "mail_style",
                        class: "fl fs14 roundForm",
                        style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                        options: _ctx.SelectUtil.commonDisplayTypes.map(m => m.name),
                        defaultOption: _ctx.requestDatesButtonType,
                        onSelectValue: _ctx.selectRequestDatesButtonType
                      }, null, 8, ["options", "defaultOption", "onSelectValue"])
                    ])
                  ])
                ]),
                _hoisted_97
              ]))
            : _createCommentVNode("", true),
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _hoisted_99,
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("div", _hoisted_104, [
                      _createVNode(_component_MdTextfieldTag, {
                        name: "",
                        style: {"height":"56px","min-width":"60px"},
                        fieldStyle: `min-width:60px;font-size:20px;`,
                        class: "fs20",
                        type: `number`,
                        min: 0,
                        max: 10,
                        value: _ctx.rcm.room_setting.email_suggests_num,
                        onInputValue: _ctx.inputEmailSuggestsNum,
                        onBlur: _ctx.blurEmailSuggestsNum
                      }, null, 8, ["value", "onInputValue", "onBlur"])
                    ])
                  ])
                ]),
                _hoisted_105
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_106, [
            _hoisted_107,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20 padw10 fw600",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showChukaiMenu && _ctx.showChukaiMenu(...args)))
            }, " 仲介メニューを表示 "),
            _hoisted_109
          ]),
          _hoisted_110
        ]))
      : _createCommentVNode("", true)
  ]))
}